import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2c824d4f")

_pushScopeId("data-v-2c824d4f")
const _hoisted_1 = { class: "checkbox-button" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("input", {
      type: "radio",
      id: _ctx.uuidValue,
      disabled: _ctx.disabled,
      checked: _ctx.checked
    }, null, 8, ["id", "disabled", "checked"]),
    _createVNode("label", {
      for: _ctx.uuidValue,
      textContent: _toDisplayString(_ctx.label)
    }, null, 8, ["for", "textContent"])
  ]))
})